import api from "@/services/external/api-service";

const url = "therapy-integration-queue";

export const insertFileToQueue = (therapy) => api().post(url, therapy);
